import { createAction, handleActions } from 'redux-actions';
import { takeLatest, call } from 'redux-saga/effects';
import * as userAPI from '../../lib/api/userapi';
import createRequestSaga, {
    createRequestActionTypes,
} from '../../lib/createRequestSaga';

/**
 * 사용자 상태 저장 리덕스 모듈 
 */

/**
 * 액션 타입 정의 
 */
// 회원가입 
const [REGIST, REGIST_SUCCESS, REGIST_FAILURE] = createRequestActionTypes(
    'user/REGIST',
);
// 로그인 
const [LOGIN, LOGIN_SUCCESS, LOGIN_FAILURE] = createRequestActionTypes(
    'user/LOGIN',
);

// 로그 아웃 
const LOGOUT = 'user/LOGOUT';

// 회원 가입 상태 초기화 
const RESET_REG_STATUS = 'user/RESET_REG_STATUS';

// 로그인 에러 처리 
const RESET_LOGIN_ERROR = 'user/REST_LOGIN_ERROR';

// Token Valid Check 
const [CHECK, CHECK_SUCCESS, CHECK_FAILURE] = createRequestActionTypes(
    'user/CHECK_TOKEN',
);

// 닉네임 변경 
const SET_NICKNAME = 'user/SET_NICKNAME';

const SET_LOGIN_INFO = 'user/SET_LOGIN_INFO';

/**
 * 견적서 요청 Action - Container 에서 요청 
 * 첫번째 인자 - ActionType
 * 두번째 인자 - 리듀서에서 처리 해야 할 Payload : 스토어에서 사용될 값 (생략가능)
 */
export const registAction = createAction(REGIST, (email, passwd, nickname, confirmData, isMkt ) => {
    return { email, passwd, nickname, confirmData, isMkt }
});
export const loginAction = createAction(LOGIN, (email, passwd) => {
    return { email, passwd }
});
export const checkAction = createAction(LOGIN, (email, confirmData) => {
    return { email, confirmData }
});

export const logoutAction = createAction(LOGOUT);
export const resetRegStatusAction = createAction(RESET_REG_STATUS);
export const restLoginErrorAction = createAction(RESET_LOGIN_ERROR);
export const checkTokenAction = createAction(CHECK);
export const setNickAction = createAction(SET_NICKNAME);
export const setLoginInfoAction = createAction(SET_LOGIN_INFO);

/**
 * Networ 통신 : Saga Lib 사용 
 */
// 회원 등록 
const registSaga = createRequestSaga(REGIST, userAPI.regist);

// 로그인 
const loginSaga = createRequestSaga(LOGIN, userAPI.login);

// Token Valid Check
const checkActionSaga = createRequestSaga(CHECK, userAPI.checkRequest);

export function* userSaga() {
    yield takeLatest(REGIST, registSaga);
    yield takeLatest(LOGIN, loginSaga);
    yield takeLatest(CHECK, checkActionSaga);
}

/**
 * 리덕스 모듈 초기값 
 */
const initialState = {
    regStatus: null,
    id: null,
    nickname: null,
    cartnum: 0,
    loginError: null,
    registError: null,
    accessToken: null,
    checkStatus: null,
    esTmpApplyProdList: null, // 임시 저장으로 회원가입 / 로그인 했을 경우 
    error: null,

};

/**
 * 리덕스 액션 연결 
 */
const userReducer = handleActions(
    {
        [REGIST_SUCCESS]: (state, { payload }) => {

            // console.log("regist success : " + JSON.stringify(payload));
            return {
                ...state,
                regStatus: payload.code,
                registError: payload.message,
            }

        },
        [REGIST_FAILURE]: (state, { payload: error }) => {

            // console.log("REG FAIL !!!")

            return {
                ...state,
                regStatus: 600,
                name: null,
                id: null,
                checkStatus: null,
                registError: error
            }
        },
        [LOGIN_SUCCESS]: (state, { payload }) => {

            // console.log("login success : " + JSON.stringify(payload));

            let loginStatus = null;
            if (payload.code !== 200) {
                loginStatus = payload;
            }

            let token = null;
            if (payload.code === 200 || payload.code * 1 === 200) {
                token = payload.accessToken;
                localStorage.setItem('token', payload.accessToken);
            }

            return ({
                ...state,
                loginError: loginStatus,
                nickname: payload.nickname,
                cartnum: payload.cartnum,
                accessToken: token,
                id: payload.id
            })
        },
        [LOGIN_FAILURE]: (state, { payload: error }) => {

            localStorage.setItem('token', null);

            return ({
                ...state,
                nickname: null,
                id: null,
                accessToken: null,
                loginError: error,
                checkStatus: null,
            })
        },
        [LOGOUT]: state => {

            localStorage.setItem('token', null);

            return ({
                ...state,
                nickname: null,
                id: null,
                accessToken: null,
                checkStatus: null,
            })
        },
        [RESET_REG_STATUS]: state => ({
            ...state,
            regStatus: null,
            registError: null,
            checkStatus: null,
        }),
        [RESET_LOGIN_ERROR]: state => ({
            ...state,
            loginError: null,
            checkStatus: null,

        }),
        [CHECK_SUCCESS]: (state, { payload }) => {
            // console.log("palyload : " + JSON.stringify(payload))

            if (payload.code !== 200) {
                // Token 초기화 
                localStorage.setItem('token', null);
                return ({
                    ...state,
                    nickname: null,
                    id: null,
                    accessToken: null,
                    checkStatus: null,
                })
            } else {
                // console.log("Token Check !!!! Success ");
                return ({ ...state });
            }

        },
        [CHECK_FAILURE]: (state, { payload }) => {
            // console.log("Network 오류일 때는 무시  " + JSON.stringify(payload));
            return ({ ...state });
        },
        [SET_NICKNAME]: (state, { payload: nickname }) => {
            return ({
                ...state,
                nickname
            })
        },
        [SET_LOGIN_INFO]: (state, { payload }) => {
            return ({
                ...state,
                nickname: payload.nickname,
                cartnum: payload.cartnum,
                accessToken: payload.accessToken,
                id: payload.id
            })
        }
    },
    initialState,
);

export default userReducer;